<template>
    <u-animate-container id="pricing" class="pricing-table-area">
        <div class="container">
            
            <div class="row">
                <div class="col-12">
                    <div class="section-title-area">
                        <h2 class="section-heading">{{ pageData.page_heading }}<span class="d-block"></span></h2>
                        <p class="section-subheading">{{ pageData.subheading }}</p>
                    </div>
                </div>
            </div>

            <!-- All Service Wrapper-->            
            <div class="row all-pricing-wrapper">
                <div 
                    class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"
                    v-for="(item, indx) of pricingData"
                    :key="indx"
                    >                    
                    <!-- <u-animate
                        name="fadeInLeft"
                        delay=".2s"
                        duration="1s"
                        :iteration="1"
                        :offset="0"
                        animateClass="animated"
                        :begin="false" 
                        > -->
                        <vue-aos animation-class="fadeInLeft animated" :threshold="indx/10">
                            <div class="pricing-table-box" :class="(item.is_popular === 'Y') ? 'active' : ''">
                                <h6 class="popular-price-tag" v-if="item.is_popular === 'Y'">Popular</h6>
                                <h4 class="pricing-table-name">{{ item.heading }}</h4>
                                <div class="pricing-table-box-price">${{ item.price }}<span>/Mo</span> </div>
                                <div class="discount-tag">{{ item.subheading }} <br><span>{{ item.billing }}</span> </div>
                                <div v-html="item.content"></div>
                                <router-link to="/account/login"><i class="flaticon-right-arrow"></i>Buy Now</router-link>
                            </div>
                        </vue-aos>
                    <!-- </u-animate> -->
                </div>
               
            </div>            
            <!-- All Service Wrapper-->
        </div>
    </u-animate-container>
</template>

<script>
import VueAos from 'vue-aos'
// import {UAnimateContainer, UAnimate} from 'vue-wow'
export default {
    components: { VueAos
        // UAnimateContainer,
        // UAnimate
    },
    data(){
        return {
            pricingData: [],
            limit: 6,
            pageData: []
        }
    },
    methods: {
        getData(){ 
            this.$http.get(`/pricing`).then(res=>{                       
                if(res.status === 200 && res.data){                    
                    if(res.data.page_data)
                        this.pageData = res.data.page_data
                    if(res.data.result)
                        this.pricingData = res.data.result
                }
            })
        }
    },
    created: function(){
        this.getData()
    }
}
</script>